"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Socket = require("./Socket");
Object.keys(_Socket).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Socket[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Socket[key];
    }
  });
});
var _socketServerResolver = require("./socketServerResolver");
Object.keys(_socketServerResolver).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _socketServerResolver[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _socketServerResolver[key];
    }
  });
});